<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-6">
            <div class="Chart">
                <canvas id="mostTruck" width="50" height="50"></canvas>
            </div>
        </div>
        <div v-if="total && total > 0" style="font-size:15px; text-align:center;">
            <label>Total:</label> {{total}}
        </div>
    </div>  
</template>
            
<script>
import Chart from 'chart.js';
import Controller from './CrtMostTruck';
export default {
  
    name: 'MostTruck', 
    components: {
    },
    
    data() {
    return {
      chart: null,
      total: 0,
      item:[],

      }
    },
    methods: Controller.methods,
    created() {
      Controller.init(this);
    },
    mounted() {

        const ctx = document.getElementById('mostTruck');
        this.chart = new Chart(ctx, {

          type: 'bar',
          data: {
            datasets: [{ 
                    label:null,
                    data: null,
                    backgroundColor: ["#EBCB38"],
                },
                {
                    label:null,
                     data: null,
                    backgroundColor: ["#C13018"],
                },
                {
                    label:null,
                     data: null,
                    backgroundColor: ["#063951"],
                },
                {
                    label:null,
                     data: null,
                    backgroundColor: ["#0D95BC"],
                },
                {
                    label:null,
                     data: null,
                    backgroundColor: ["#90EE90"],
                }],

            labels: ['Caminhões'],
        },
        options: {
            /*responsive: true,
            events: false,
            tooltips: {
                enabled: false
            },
            hover: {
                animationDuration: 0
            },*/
             title: {
                display: true, 
            },
            legend: {
                fullWidth: true,
                labels: {
                    fontColor: '#000',
                    boxWidth: 20,
                }
            },
            /*animation: {
                onComplete: function () {
                    var chartInstance = this.chart,
                    ctx = chartInstance.ctx;
                    ctx.font = Chart.helpers.fontString(10, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'center';

                    this.data.datasets.forEach(function (dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        meta.data.forEach(function (bar, index) {
                            var data = dataset.data[index];
                            ctx.fillText(data, bar._model.x, bar._model.y - 5);
                        });
                    });
                }
            }*/
        }
      });
    }
}
    

</script>
